'use es6';

import UIAlert from 'UIComponents/alert/UIAlert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { DISABLE_CUSTOM_JITA_UI } from 'page-editor-ui/redux/selectors/testFlagSelectors';
import { setTemporaryTestFlag } from 'ContentEditorUI/lib/testFlags';

// Add `#testFlags=disableCustomJitaUI` to temporarily disable the custom JITA UI and see what
// a customer would see
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const disableCustomJitaUIViaTestFlag = () => {
  setTemporaryTestFlag(DISABLE_CUSTOM_JITA_UI);
};
const JitadAndCantSaveWarning = () => /*#__PURE__*/_jsx(UIAlert, {
  type: "warning",
  children: /*#__PURE__*/_jsxs(UIButtonWrapper, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: `jitadAndCantSaveWarning.title`
    }), /*#__PURE__*/_jsx(UITooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `jitadAndCantSaveWarning.tooltipAndMakeReadOnly`
      }),
      children: /*#__PURE__*/_jsx(UIButton, {
        size: "extra-small",
        use: "tertiary-light",
        onClick: disableCustomJitaUIViaTestFlag,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `jitadAndCantSaveWarning.disableCustomJitaUIButton`
        })
      })
    })]
  })
});
export default JitadAndCantSaveWarning;